export function PageSkeleton({
  variant = 'cards',
}: {
  variant?: 'cards' | 'list' | 'table' | 'detail' | 'rows' | 'board'
}) {
  if (variant === 'list') {
    return (
      <div className="space-y-3">
        {[0, 1, 2, 3].map((item) => (
          <div key={item} className="h-24 animate-pulse rounded-xl bg-gray-100" />
        ))}
      </div>
    )
  }

  if (variant === 'rows') {
    return (
      <div className="space-y-3 py-2">
        {[0, 1, 2].map((item) => (
          <div key={item} className="h-16 animate-pulse rounded-xl bg-gray-100" />
        ))}
      </div>
    )
  }

  if (variant === 'table') {
    return (
      <div className="space-y-3">
        <div className="h-8 animate-pulse rounded-lg bg-gray-100" />
        {[0, 1, 2, 3, 4].map((item) => (
          <div key={item} className="h-10 animate-pulse rounded-lg bg-gray-50" />
        ))}
      </div>
    )
  }

  if (variant === 'board') {
    return (
      <div className="mt-5 flex items-start gap-4 overflow-x-auto pb-4">
        {[0, 1, 2, 3].map((item) => (
          <div key={item} className="min-w-[280px] flex-1 space-y-3">
            <div className="h-8 w-28 animate-pulse rounded-full bg-gray-100" />
            <div className="h-28 animate-pulse rounded-xl bg-gray-100" />
            <div className="h-28 animate-pulse rounded-xl bg-gray-100" />
          </div>
        ))}
      </div>
    )
  }

  if (variant === 'detail') {
    return (
      <div className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6">
        <div className="h-10 w-72 animate-pulse rounded-xl bg-gray-100" />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {[0, 1, 2].map((item) => (
            <div key={item} className="h-28 animate-pulse rounded-2xl bg-gray-100" />
          ))}
        </div>
        <div className="h-64 animate-pulse rounded-2xl bg-gray-100" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {[0, 1, 2].map((item) => (
          <div key={item} className="h-36 animate-pulse rounded-2xl bg-gray-100" />
        ))}
      </div>
      <div className="h-64 animate-pulse rounded-2xl bg-gray-100" />
    </div>
  )
}
